import './navigation';
import './header';
import './ajax-add-to-cart';

const showFormButtons = document.querySelectorAll('.showFormButton');
const contactForm = document.querySelector('.contactForm');
const hideFormButton = document.getElementById('close__form');

if (showFormButtons) {
    showFormButtons.forEach((button) => {
        button.addEventListener('click', () => {
            contactForm.classList.add('active');
        });
    });
}

if (hideFormButton) {
    hideFormButton.addEventListener('click', () => {
        contactForm.classList.remove('active');
    });
}
